import { Model } from 'es6/components/model'

/**
 * Модель для поселений
 */
export class Settlement extends Model {}
